<template>
    <div>
      <div id="referenciaDesaparecen">
          <div id="referenciaDesaparecen1">
              <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickAlta()">Alta</b-button>
              <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickModificar()">Modificar</b-button>   
              <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickEliminar()">Eliminar</b-button> 
              <b-button v-b-modal.modal-buscar class="btn btn-success btn_desap" @click="">Buscar</b-button>
          </div>  
      </div>

      <b-modal id="modal-Foto" title="Seleccionar Foto" size="xl" ok-only>
        <div class="container">
            <div class="row" style="margin-top:10px; text-align:center;">
                <div v-for="item in array_fotos" class="col redondeado" style="margin-top:10px;">
                    <div class="margen5" @click="seleccionarDIV(item)" v-bind:id="item.id" style="margin-top:10px; position: relative;">
                        <b-img :src="item.imagen64" fluid alt="Responsive image" style="height: 80px; width: 240px;"></b-img>
                    </div>
                    <div class="redondeado" v-bind:id="'descrp-'+item.id" style=" margin: auto;margin-top:10px; background:#000000; color:#FFFFFF;font-size:12px; width: 150px;">{{ item.des_12c }}</div>
                </div>
            </div>
        </div>
      </b-modal>

      <b-modal id="modal-alta" 
          header-bg-variant="success"
          size="xl"
          :title="titulo +' Articulos'"
          @show.bs.modal="CargarSummernote">
          <div class="modal-body">
              <b-alert v-model="showAlert" variant="danger" dismissible>
                   La foto no se puede seleccionada no tiene la proporcion para ser usada en el Carurel
              </b-alert>
              <div class="form-group">  
                  <label >Titulo:</label>
                  <b-form-input  type="text" v-model="tituloArticulo" maxlength="60" :state="estadoTitulo"  style="width:500px;" trim></b-form-input>
                  <b-form-checkbox v-model="carousel" value="Si" unchecked-value="No" @change="evaluarFoto()" >Carousel</b-form-checkbox>              
              </div> <!-- -->            
              <div class="form-group" >
                <label>Descripcion:</label> 
                <b-form-textarea id="descripcion" v-model="descripcion" :state="descripcion.length >= 10" 
                rows="2" maxlength="245" style="width:500px;"></b-form-textarea>
              </div>  
              <b-button v-b-modal.modal-Foto variant="success">Seleccionar Foto</b-button>
              <b-img :src="this.imagen64" fluid alt="Responsive image" style="height: 80px; width: 240px;"></b-img>             
              <textarea id="summernote" name="editordata"></textarea>  
          </div>
          <template v-slot:modal-footer="{ ok }" >
              <b-button id='Boton_Alta' :hidden="mostrarBotonAlta" variant="success" @click="altaArticulos()">Guardar Artículos</b-button>
              <b-button id='Boton_Modificar' :hidden="mostrarBotonModificar" variant="success" :disabled="bloquear_ME" @click="modificarArticulos()">Guardar Artículos</b-button>
              <b-button id='Boton_Eliminar' :hidden="mostrarBotonEliminar" variant="danger" :disabled="bloquear_ME" @click="eliminarArticulos()">Eliminar Artículos</b-button>
              <b-button id="BotonOkAlta" variant="secondary" @click="ok()">Cancelar</b-button>

          </template>

      </b-modal>
             

    <b-table hover 
        small
        selectable
        sticky-header="500px"
        select-mode="single" 
        @row-selected="onRowSelected" 
        :fields="EncabezadoArticulos"       
        :items="array_articulos"      
        :filter="criterio" 
        :filter-function="filtroCarousell">
        <template v-slot:cell(Fotos)="row">
            <b-img v-if="row.item.carousel=='Si'" :src="row.item.imagen64" fluid alt="Responsive image" style="height: 80px; width:240px;"></b-img>
            <b-img v-if="row.item.carousel=='No'" :src="row.item.imagen64" fluid alt="Responsive image" style="height: 80px; width:80px;"></b-img>            
        </template>
    </b-table>

    <b-modal id="modal-buscar" title="Buscar" ok-only>
        <div class="">
            <div>
                <label for="titulo-buscar">Titulo:</label>
                <b-form-input  id="titulo-buscar" type="text" v-model="criterio[0]" trim></b-form-input>
                <b-form-checkbox v-model="criterio[1]" value="Si" unchecked-value="No">Carousel</b-form-checkbox>
            </div>
        </div>
    </b-modal>

    </div>
</template>

<style>

</style>

<script>
  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'

  const $ = require("jquery")
  import "summernote/dist/summernote-lite.min.css";
  import "summernote/dist/summernote-lite.min"; 

  export default {
    name: 'Home', 
    components: {
  
    },
    computed:{
        ...mapState(['host','array_fotos','array_articulos','array_usuario']),

        mostrarBotonAlta(){
          return this.titulo=='Alta de' ? false : true
        },
        mostrarBotonModificar(){
          return this.titulo=='Modificar' ? false : true
        },
        mostrarBotonEliminar(){
          return this.titulo=='Eliminar' ? false : true
        },
        bloquear_ME(){
          return this.id!=0 ? false : true
        },
        estadoTitulo(){
          return this.tituloArticulo.length >= 10 ? true : false 
        },

    },  
    methods:{
      ...mapActions(['CargarFotos','CargarArticulos']), 

      evaluarFoto(){
          if (this.carousel=='Si') {
              if (this.ancho/this.alto<3.9 || this.ancho/this.alto>4.1){
                  //alert('La imagen que se trata de guardar no es adecudada para el Carousel');
                  this.carousel='No';
                  this.showAlert=true;
              }
          }
      },    
      seleccionarDIV(divss){
          this.id_foto=divss.id;
          this.imagen64=divss.imagen64;
          this.$bvModal.hide('modal-Foto');

          var img = new Image();       
          img.src = this.imagen64;
          this.ancho=img.width;
          this.alto=img.height;
          this.evaluarFoto();
      },
      altaArticulos: async function (){
          document.getElementById('BotonOkAlta').click();

          try{
              let newPost={
                  opcion:'Alta',
                  id_foto:this.id_foto,
                  tituloArticulo:this.tituloArticulo,
                  descripcion:this.descripcion,
                  texto:this.texto,
                  carousel:this.carousel,
                  texto:document.getElementById('summernote').value,
                  session:this.array_usuario.session
              };
              const entradasBD = await fetch(this.host+'articulos.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.CargarArticulos();
              this.imagen64='';
              this.id_foto=0;
          }catch (error){
              console.log(error);
          }  
      },
      modificarArticulos: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              console.log(this.carousel);
              let newPost={
                  opcion:'Modificar',
                  id:this.id,
                  id_foto:this.id_foto,
                  tituloArticulo:this.tituloArticulo,
                  descripcion:this.descripcion,
                  texto:this.texto,
                  carousel:this.carousel,
                  texto:document.getElementById('summernote').value,
                  session:this.array_usuario.session
                };
              const entradasBD = await fetch(this.host+'articulos.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.id=0;
              this.imagen64='';
              this.id_foto=0;
              this.CargarArticulos();                            
          }catch (error){
              console.log(error);
          }  
      },
      CargarSummernote(){
        $(document).ready(function() {
          $('#summernote').summernote({
            lang: 'es-ES', 
            tabsize: 4,
            toolbar: [
              ['style', ['style']],
              ['font', ['bold', 'underline', 'clear']],
              ['color', ['color']],
              ['para', ['ul', 'ol', 'paragraph']],
              ['table', ['table']],
              ['insert', ['link', 'picture', 'video']],
              ['view', ['fullscreen', 'codeview', 'help']]
            ]
          });
        })
      },

      clickAlta() {
        this.titulo='Alta de';
        this.id=0;
        this.tituloArticulo='';
        this.descripcion='';
        this.texto='';
        this.carousel='No';
        this.imagen64='';
        this.ancho=1;
        this.alto=1;
        $('#summernote').summernote('reset');
        this.showAlert=false;
      },

      clickModificar() {
        this.titulo='Modificar';
        console.log(this.texto)
        var valor=this.texto
        $(document).ready(function() {
          $('#summernote').summernote('code',valor);
        });
        this.showAlert=false;        
      },

      clickEliminar() {
        this.titulo='Eliminar';
        //this.valorBotonEliminar(this.cant_expedientes);
      },        

      filtroCarousell(row, filter) {
        if (row.titulo.toUpperCase().includes(filter[0].toUpperCase()) && row.carousel === filter[1]) {
          return true;
        } else {
          return false;
        }
      },

      onRowSelected(items) {
        if (items.length==1){
          this.id=items[0]['id'];
          this.tituloArticulo=items[0]['titulo'];
          this.descripcion=items[0]['descripcion'];
          this.texto=items[0]['texto'];
          this.carousel=items[0]['carousel'];
          this.imagen64=items[0]['imagen64'];
          this.id_foto=items[0]['id_foto'];
          var img = new Image();       
          img.src = this.imagen64;
          this.ancho=img.width;
          this.alto=img.height;

        }
      },

      readySummernote(editor) {
          editor.summernote('code', this.contents);
          editor.$on("change", contents => {
              this.texto = contents;
          });
      },      
    },

    data() {
      return {
          id:0,
          carousel:'No',
          criterio:['','Si'],
          titulo:'',
          descripcion:'',
          texto:'',
          tituloArticulo:'',
          id_foto:0,
          imagen64:'',

          fotoCarusell:false,
          ancho:1,
          alto:1,
          showAlert:false,
          EncabezadoArticulos: [
            {
              key: 'fecha',
              label: 'Fecha',
              sortable: true,
              formatter: (value, key, item) => {
                return value.substring(8,10)+'/'+value.substring(5,7)+'/'+value.substring(0, 4);
              },            
            },            
            {
              key: 'titulo',
              label: 'Titulo',
              sortable: true
            },
            {
              key: 'descripcion',
              label: 'Desripcion',
            },
            {
              key: 'carousel',
              label: 'Carousel',
              sortable: true
            },                    
              'Fotos'
            , 
          ],
      }
    },   
    created(){
        this.CargarArticulos();
        this.CargarFotos();
    }
  }
</script>
